<template>
  <div>
    <div class="w-full text-center px-4 py-2 m-2 ml-auto mr-auto">
      <h1>{{ getText('preview_title') }}</h1>
      <div class="ml-auto mr-auto text-center" id="preview">
        <img :src="'data:image/png;base64,' + previewImage" class="inline-block" />
      </div>
      <div class="ml-auto mr-auto mt-10" style="width: 848px">
        <button
          class="py-3 px-10 rounded-full w-full border-2 border-white text-white border-solid"
          style="color: white !important"
          @click="previousStep()"
        >{{ getText('button_repeat' )}}</button>
        <button
          class="bg-white text-black font-bold py-3 px-10 rounded-full w-full mt-5"
          @click="nextStep()"
        >{{ this.getText('button_save')}}</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
h1 {
  font-family: FoundryWilsonMedium;
  font-size: 66px;
  text-transform: uppercase;
  width: 1100px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 72px;
  text-align: center;
}

#preview {
  margin-top: 96px;
  width: 848px;
  height: 480px;
}
</style>

<script>
export default {
  name: "Preview",

  methods: {
    getText(key) {
      return this.$settings.interface[key][this.$route.params.lang];
    },

    previousStep() {
      this.$router.push("/photo/" + this.$route.params.lang);
    },

    nextStep() {
      this.$router.push("/selection/" + this.$route.params.lang);
    },
  },

  data() {
    return {
      previewImage: null
    };
  },

  mounted() {
    this.previewImage = this.$variables.photoBase64;
  },

  beforeDestroy() {
  }
};
</script>